module.exports = __webpack_public_path__ + "img/swiptt.665130f0.png";